module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Loading":"Loading in progress"},"fr":{"Loading":"Chargement en cours"}}')
  delete Component.options._Ctor
}
